import { useEffect, useState } from 'react';

import { getBookableVessels } from '@/actions/calculator/bookable-vessels-user-facing-booking-functionality';
import { ResponseType } from '@/types/response-types';

export const useClientBookableVessels = () => {
    const [bookableVessels, setBookableVessels] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchBookableVessels() {
            try {
                setIsLoading(true);
                const response = await getBookableVessels();
                if (response.status === ResponseType.SUCCESS) {
                    setBookableVessels(response.data);
                } else {
                    console.error('Failed to fetch bookable vessels:', response.error);
                }
            } catch (error) {
                console.error('Error fetching bookable vessels:', error);
            } finally {
                setIsLoading(false);
            }
        }

        void fetchBookableVessels();
    }, []);

    return {
        bookableVessels,
        isLoading,
    };
};
